(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tll-welcome-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tll-welcome-offer')) {
    customElements.define('tll-welcome-offer', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const dialog = this.querySelector('dialog');
        const launcher = this.querySelector('.tllw-launch');
        const form = this.querySelector('form');
        if (!dialog || !launcher || typeof dialog.showModal !== 'function') return;
        const key = 'tll_welcome_offer_v1';
        const read = () => { try { return localStorage.getItem(key); } catch { return null; } };
        let status = read();
        let closingForSubmit = false;
        const designMode = this.dataset.designMode === 'true';
        const currentStatus = () => {
          const stored = read();
          if (stored === 'dismissed' || stored === 'subscribed') status = stored;
          return status;
        };
        const remember = value => { status = value; try { localStorage.setItem(key, value); } catch {} };
        const settled = () => ['dismissed', 'subscribed'].includes(currentStatus());
        const updateLauncher = () => {
          launcher.hidden = dialog.open || (!designMode && currentStatus() !== 'dismissed');
        };
        const open = () => {
          if (dialog.open || document.querySelector('dialog[open]')) return;
          this.returnFocus = document.activeElement;
          dialog.showModal();
          launcher.hidden = true;
          document.documentElement.classList.add('tllw-is-open');
        };
        const close = () => dialog.close();
        form.addEventListener('submit', () => {
          if (dialog.open) {
            closingForSubmit = true;
            dialog.close();
          }
        }, {capture:true});
        launcher.addEventListener('click', open);
        this.querySelector('.tllw-close').addEventListener('click', close);
        this.querySelector('.tllw-later').addEventListener('click', close);
        dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if(event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(); } });
        dialog.addEventListener('close', () => {
          if (!closingForSubmit && currentStatus() !== 'subscribed') remember('dismissed');
          closingForSubmit = false;
          document.documentElement.classList.remove('tllw-is-open');
          updateLauncher();
          if (this.returnFocus?.isConnected) this.returnFocus.focus({preventScroll:true});
        });
        const fromThisForm = location.hash === '#tll-welcome-form';
        const success = Boolean(this.querySelector('[data-tllw-success]'));
        const error = Boolean(this.querySelector('[data-tllw-error]'));
        if (success) remember('subscribed');
        updateLauncher();
        if (fromThisForm && (success || error)) { open(); return; }
        if (settled() || designMode) return;
        const attempt = () => {
          if (!this.isConnected) return;
          if (settled()) { updateLauncher(); return; }
          const busy = document.hidden || document.querySelector('dialog[open]') || document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
          if (busy) { this.timer = setTimeout(attempt, 2000); return; }
          open();
        };
        this.timer = setTimeout(attempt, 1800);
      }
      disconnectedCallback() { clearTimeout(this.timer); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
